/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import {
    func, string, object, bool, number,
} from 'prop-types';
import {
    Grid,
    Button,
    CircularProgress,
} from '@material-ui/core';
import { dateMMMMDDYYYY, DDMMMYY } from '../../../../utils/dateString';
import { formatPhoneNumber } from '../../../../utils/formater';
import configENV from '../../../../config';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import { enterpriseCSS } from '../../../../style/variables';
import customBreakpoints from '../../../../../../helpers/customBreakpoints';
import { isEmpty } from '../../../../utils/object';
import Helper from '../../../../state/reducers/Helper';
import LinkOpenChat from '../../../../common/LinkOpenChat';

const styles = (theme) => ({
    orderConfirmationRoot: {
        height: '312px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            minHeight: '480px',
            height: 'auto',
        },
    },
    nextButton: {
        backgroundColor: theme.palette.colorPrimaryAccountCtaButton,
        color: theme.palette.common.white || '#fff',
        textTransform: 'capitalize',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: theme.palette.colorPrimaryAccountCtaButton,
            opacity: .90,
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '20px',
        },
    },
    backButton: {
        textTransform: 'capitalize',
        fontWeight: 'bold',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            borderRadius: '20px',
        },
    },
    buttonWrap: {
        position: 'sticky',
        bottom: 0,
        backgroundColor: theme.palette.common.white || '#fff',
        paddingBottom: '20px',
        marginTop: '50px'
    },
    imageWrap: {
        textAlign: 'center',
    },
    thankyouImage: {
        width: '273px',
    },
    errorIconWrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '6vh',
    },
    errorIcon: {
        width: '80.76px',
    },
    errorText: {
        textAlign: 'center',
        marginBottom: '10vh',
        '& span': {
           textDecoration: 'underline',
           color: enterpriseCSS.palette.blue,
           cursor: 'pointer'
        }
    },
    closeWindowWrap: {
      textAlign: 'center',
      '& a': {
        textDecoration: 'none',
      }
    },
    closeWindow: {
        margin: '0 auto 30px',
        width: '50%',
        textTransform: 'capitalize',
        backgroundColor: theme.palette.colorPrimaryAccountCtaButton,
        color: theme.palette.common.white || '#fff',
        underline: 'none',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            width: '100%',
            borderRadius: '20px',
        },
        '&:hover': {
         backgroundColor: theme.palette.colorPrimaryAccountCtaButton,
         opacity: .90,
        },
    },
    title: {
        color: theme.palette.text.secondary || '#aeaeae',
        textTransform: 'uppercase',
        paddingBottom: '5px',
        fontSize: '18px',
    },
    lineBreak: {
        borderBottom: `1px solid ${enterpriseCSS.palette.gray3 || '#EDEDEA'}`,
        paddingBottom: '20px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            marginBottom: '20px',
        },
    },

    recipientInfo:{
        paddingRight:'5px',
    },
    noCardMessage: {
        color: theme.palette.text.disabled,
    },
    giftMessage: {
        overflowWrap: 'break-word',
    },
    companyName: {
      wordBreak: 'break-all'
    },
    lineWrap:{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    }
});

const { PERSIST_KEY } = configENV;

const ModifyOrderConfirmation = ({
    submitModifiedOrder, checkForConfirmationScreen, modifiedRecipientAddress, modifiedDate, modifiedGiftMsg,
    closeMMO, ROSSOrder, fetchProductAvailability, productAvilableStatus, productAvailable,
    getBackToDeliveryDate, isDeliveryDateChanged, isRecipientAddressChanged, isGiftMessageChanged, isAuthorChanged, classes,
    history, modifiedAuthor, isMobile, modifiedDeliveryMethod, modifiedOrderResponseStatus, recipientSeqNumber,
    modifyEligibility = {}, changeTabs, modifiedOrderError, modifiedOrder, promCodeFlag, isUsingCheckoutGiftMessageForm,
    modifiedDeliveryDateSurcharge, ROSSOrderTotal, sourceId, isUsingV1DeliveryDatesEndpoint, deliverySLA
}) => {
    const [isThankYouScreenOn, setThankYouScreen] = useState(false);
    const [isLoading, setLoadingScreen] = useState(false);
    const isProductAvailabilityLoading = isUsingV1DeliveryDatesEndpoint && isDeliveryDateChanged && productAvilableStatus !== 200;
    const isOrderModified = isRecipientAddressChanged || isDeliveryDateChanged || isGiftMessageChanged || isAuthorChanged;
    const bcsOrderNumber = ROSSOrder?.bcsOrderNumber || '';
    const options = {
        Residence: '1',
        Business: '2',
        'Funeral Home': '4',
        Hospital: '5',
        Apartment: '6',
        School: '8',
        'APO/FPO': '9',
        'P.O.Box': '10',
        Church: '11',
    };
    useEffect(() => {
        if (isUsingV1DeliveryDatesEndpoint && isDeliveryDateChanged) {
            const productAvailabilityPayload = {
                zipCode: modifiedRecipientAddress?.zipCode,
                state: modifiedRecipientAddress?.state,
                productSku: ROSSOrder.items?.[0]?.productSku,
                locationType: options[modifiedRecipientAddress?.locationType],
                brandId: ROSSOrder.items?.[0]?.productBrand,
                deliveryDate: DDMMMYY(modifiedDate),
                promCode: Helper?.getPromCode(ROSSOrder?.items?.[0]?.productBrand, promCodeFlag),
                deliveryMethod: modifiedDeliveryMethod,
                itemQuantity: `${ROSSOrder?.items?.[0]?.quantity}` || '1',
                itemTypeCode: '2',
                fulFillSku: '',
                lineNumber: '',
                recipNumber: '',
            };
            fetchProductAvailability(productAvailabilityPayload);
        }
    }, []);

    const prepareRecipientAddress = () => {
        const updatedRecipient = {
            ...modifiedRecipientAddress,
            locationType: options[modifiedRecipientAddress.locationType],
        };
        return updatedRecipient;
    };

    const submitOrder = async () => {
        const productBrand = ROSSOrder?.items?.[0]?.productBrand || '';
        const isRaisedBrand = ['1018', '1019', '1020', '1031'].includes(productBrand); // STY, HD, WLF
        let message = modifiedAuthor ? `${modifiedGiftMsg}\n- ${modifiedAuthor}` : modifiedGiftMsg;
        if (isUsingCheckoutGiftMessageForm && isRaisedBrand) { // For HD brands
            const raisedBrandMessage = modifiedGiftMsg?.includes('\n') ? modifiedGiftMsg.replaceAll('\n', '<NL/>') : modifiedGiftMsg;
            message = modifiedAuthor ? `${raisedBrandMessage}<NL/>From:${modifiedAuthor}` : raisedBrandMessage;
        }
        const giftMsg = message;
        const modifyOrderPayload = {
            orderId: ROSSOrder?.orderNumber,
            brandId: productBrand,
            brandOrderId: ROSSOrder?.brandOrderNum,
            deliveryDate: DDMMMYY(modifiedDate) || '',
            surcharges: modifiedDeliveryDateSurcharge || 0,
            message: giftMsg || '',
            address: prepareRecipientAddress(),
            channel: '30016', // 30016 is default value, will override in Services
            sequenceNumber: ROSSOrder?.items?.[0]?.sequenceNumber,
            recipientSeqNumber,
            fieldChanges: {
                recipientAddress: isRecipientAddressChanged,
                deliveryDate: isDeliveryDateChanged,
                cardMessage: isGiftMessageChanged,
            },
            orderTotal: ROSSOrderTotal,
            bcsOrderNumber,
            sourceId: sourceId,
            deliveryMethod: deliverySLA,
        };
        if (isUsingV1DeliveryDatesEndpoint && isDeliveryDateChanged && productAvilableStatus === 200) {
            if (productAvailable === 'true') {
                setLoadingScreen(true);
                await submitModifiedOrder(modifyOrderPayload);
                setLoadingScreen(false);
                setThankYouScreen(true);
            } else {
                checkForConfirmationScreen(false);
                getBackToDeliveryDate(1);
            }
        } else {
            setLoadingScreen(true);
            await submitModifiedOrder(modifyOrderPayload);
            setLoadingScreen(false);
            setThankYouScreen(true);
        }
    };
    const onGoBack = () => {
        const { isDeliveryDateModifiable, isCardMsgModifiable } = modifyEligibility;
        checkForConfirmationScreen(false);
        if (isCardMsgModifiable === true) {
            changeTabs(2);
        } else if (isDeliveryDateModifiable === true) {
            changeTabs(1); 
        } else {
            changeTabs(0);
        }
    };

    const onCloseWindow = () => {
        closeMMO();
        if (typeof window !== 'undefined') {
            history.go(); // hard reload page to have 30 min lock from ROSS
        }
        return null;
    };

    return (
        <>
            {!isThankYouScreenOn
                ? (
                    <div>
                        {
                            isLoading ? (
                                <CircularProgress color="inherit" size={25} />
                            ) : (
                                <div className={classes.orderConfirmationRoot}>
                                    <p className={classes.lineBreak}>
                                        {!isOrderModified
                                            ? (<>No changes were made. Please <b>Go Back</b> to modify.</>)
                                            : (<>Once you <b>Submit</b>, you cannot make any other changes for <b>30 minutes</b>.</>)}
                                    </p>

                                    <Grid container xs={12}>
                                        <Grid item xs={12} sm={4} md={4} className={isMobile ? classes.lineBreak : classes.recipientInfo}>
                                            <div className={classes.title}>Recipient</div>
                                            <div className={classes.lineWrap}>
                                               {modifiedRecipientAddress.firstName}
                                            </div>
                                            <div className={classes.lineWrap}>
                                                {modifiedRecipientAddress.lastName}
                                            </div>
                                            <div className={classes.companyName}>{modifiedRecipientAddress.company}</div>
                                            <div>{modifiedRecipientAddress.addressLine1}</div>
                                            <div>{modifiedRecipientAddress.addressLine2}</div>
                                            <div>{`${modifiedRecipientAddress.cityName}, ${modifiedRecipientAddress.state} ${modifiedRecipientAddress.zipCode}`}</div>
                                            <div>{formatPhoneNumber(modifiedRecipientAddress.phoneNumber)}</div>
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4} className={isMobile ? classes.lineBreak : null}>
                                            <div className={classes.title}>Delivery date</div>
                                            <div>{dateMMMMDDYYYY(modifiedDate)}</div>
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <div className={classes.title}>Gift Message</div>
                                            <div className={classes.giftMessage}>{modifiedGiftMsg === '' ? <span className={classes.noCardMessage}>No Card Message Entered</span> : modifiedGiftMsg}</div>
                                            <div>{modifiedAuthor}</div>
                                        </Grid>
                                    </Grid>
                                </div>
                            )
                        }
                        <Grid container xs={12} spacing={2} className={classes.buttonWrap}>
                            <Grid item xs={6}>
                                <Button className={classes.backButton} variant="outlined" fullWidth onClick={onGoBack}>Go Back</Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button className={classes.nextButton} disabled={(isUsingV1DeliveryDatesEndpoint && isProductAvailabilityLoading) || !isOrderModified} variant="contained" fullWidth onClick={submitOrder}>
                                    {
                                        isUsingV1DeliveryDatesEndpoint && isProductAvailabilityLoading ? (
                                            <CircularProgress color="inherit" size={25} />
                                        ) : (
                                            'Submit'
                                        )
                                    }
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                )
                : (
                    <>
                        {/* loading condition - show spinner */}
                        {
                            isEmpty(modifiedOrder) && isEmpty(modifiedOrderError) && !modifiedOrderResponseStatus && (
                                <>
                                    <div className={classes.errorIconWrap}>
                                        <CircularProgress color="inherit" />
                                    </div>
                                    <Button className={classes.closeWindow} variant="contained" color="primary" disabled onClick={onCloseWindow}>Close</Button>
                                </>
                            )
                        }
                        {/* error condition - hit catch or order failed to update */}
                        {
                            !isEmpty(modifiedOrderError) || (modifiedOrderResponseStatus && modifiedOrderResponseStatus !== 201)
                                ? (
                                    <>
                                        <div className={classes.errorIconWrap}>
                                            <img className={classes.errorIcon} src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt91127120f3d66c9b/607be57feea64578d07fc8c1/Hazard_Oops_Icon.svg" alt="sorry-error" />
                                        </div>
                                        <div className={classes.errorText}>
                                            <p>Sorry, there was problem updating your order.</p>
                                            <p>Please try again later. For immediate assistance, please <span onClick={closeMMO}><LinkOpenChat>chat with us.</LinkOpenChat></span></p>
                                        </div>
                                        <div className={classes.closeWindowWrap}>
                                          <LinkOpenChat><Button className={classes.closeWindow} variant="contained" color="primary" onClick={closeMMO}>Chat now</Button></LinkOpenChat>
                                        </div>
                                    </>
                                ) : null
                        }
                        {/* success condition - order had a 201 status from the endpoint and CSI successfully submitted */}
                        {
                            !isEmpty(modifiedOrder) && modifiedOrderResponseStatus === 201
                                ? (
                                    <>
                                        <div className={classes.imageWrap}>
                                            <img className={classes.thankyouImage} src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blta9405e50fb3f59ac/6063b5cebc3ffc1037a40465/MMO_Thank_You_Graphic_(1).svg" alt="thank you" />
                                            <div><b>Thank You!</b></div>
                                        </div>
                                        <div>
                                            <p>We are processing the requested changes. Once the changes have been processed, you will receive an email confirming your changes.</p>
                                            <p>You cannot make any other changes online for 30 minutes. It may take up to 30 minutes for your Order Details to reflect these changes.</p>
                                        </div>
                                        <Button className={classes.closeWindow} variant="contained" color="primary" onClick={onCloseWindow}>Close</Button>
                                    </>
                                ) : null
                        }
                    </>
                )}
        </>
    );
};

ModifyOrderConfirmation.propTypes = {
    submitModifiedOrder: func.isRequired,
    checkForConfirmationScreen: func.isRequired,
    modifiedRecipientAddress: object.isRequired,
    modifiedDate: string.isRequired,
    modifiedGiftMsg: string.isRequired,
    modifiedAuthor: string.isRequired,
    closeMMO: func.isRequired,
    ROSSOrder: object.isRequired,
    productAvailable: string.isRequired,
    fetchProductAvailability: func.isRequired,
    productAvilableStatus: number.isRequired,
    getBackToDeliveryDate: func.isRequired,
    isDeliveryDateChanged: bool.isRequired,
    isRecipientAddressChanged: bool.isRequired,
    isGiftMessageChanged: bool.isRequired,
    isAuthorChanged: bool.isRequired,
    classes: object.isRequired,
    history: object.isRequired,
    isMobile: bool.isRequired,
    modifiedDeliveryMethod: string.isRequired,
    modifiedOrderResponseStatus: number.isRequired,
    recipientSeqNumber: string.isRequired,
    modifyEligibility: object.isRequired,
    changeTabs: func.isRequired,
    modifiedOrderError: object.isRequired,
    modifiedOrder: object.isRequired,
    promCodeFlag: bool.isRequired,
    isUsingCheckoutGiftMessageForm: bool.isRequired,
    modifiedDeliveryDateSurcharge: number.isRequired,
    ROSSOrderTotal: string.isRequired,
    deliverySLA: string.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        productAvailable: newState.productAvailable,
        productAvilableStatus: newState.productAvilableStatus,
        modifiedOrder: newState.modifiedOrder,
        modifiedOrderResponseStatus: newState.modifiedOrderResponseStatus,
        modifiedOrderError: newState.modifiedOrderError,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchProductAvailability: (payload) => dispatch(EventDispatcher.handleFetchProductAvailability(payload)),
});

const StyledModifyOrderConfirmation = withStyles(styles)(ModifyOrderConfirmation);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StyledModifyOrderConfirmation));
